import React, { ReactElement, useEffect, useRef } from "react";
import {
  adsenseClientId,
  adsenseScenariosListTopSlot,
  initializeAdsenseAd,
} from "../../utils/adsense";
import "./ScenariosListTopAd.less";

export default (): ReactElement | null => {
  const adRef = useRef<HTMLModElement>(null);

  useEffect(() => {
    initializeAdsenseAd(adRef.current);
  }, []);

  if (!adsenseClientId || !adsenseScenariosListTopSlot) {
    return null;
  }

  return (
    <div className="scenarios-list-top-ad-layout">
      <div className="scenarios-list-top-ad-layout-inner">
        <aside className="scenarios-list-top-ad" aria-label="Advertisement">
          <ins
            ref={adRef}
            className="adsbygoogle"
            style={{ display: "block" }}
            data-ad-client={adsenseClientId}
            data-ad-slot={adsenseScenariosListTopSlot}
            data-ad-format="auto"
            data-full-width-responsive="true"
          />
        </aside>
      </div>
    </div>
  );
};
